import * as React from 'react';
import { IBirthdayUser } from '../../../interfaces/IBirthdayUser';
import { IAPeopleCard } from './peopleCard/peopleCard';
import * as styles from './CardView.css';
import { Helper } from "../../../Helper";
import { Environment } from "../../../services/Environment";
import { IACardViewService } from '../../messagesCardView/CardView.service';
import { ConditionalOutput } from '../../../services/ConditionalOutput';
import { LocalizationService } from '../../../services/LocalizationService';
import { IEnvironment } from '../../../interfaces/IEnvironment';
import { IFontSlots } from '../../../interfaces/IFontSlots';

export interface IProps {
  users: IBirthdayUser[];
  properties: string[];
  settings: any;
  tenant: string;
  token: string;
  environment: IEnvironment;
  width: number;
  highlightColor: string;
  todayIcon?: string;
  isMobile?: boolean;
  showAnniversaryYear?: boolean;
  isEditMode?: boolean;
  borderRadius?: string | number;
  fontSlots?: IFontSlots;
}

export interface IState {
}

export class IACardView extends React.Component<IProps, IState> {
  private cardViewService: IACardViewService = new IACardViewService();

  constructor(props: IProps) {
    super(props);
    this.state = {
    };

  }

  public render(): JSX.Element {

    let users = [];

    // Resizing cards
    const [numberOfCardsPerRow, maxCardWidthAvailable] = this.cardViewService.getNumberOfCardsPerRowAndMaxCardWidthAvailable(this.props.width, 20, 212);
    let currentRowNumber = 1;
    let cardsOnPage = 0;

    if (this.props.users && this.props.users.length > 0) {
      this.props.users.forEach(user => {
        let birthdayString = this.props.settings.isBirthday ? user.birthdayText : user.anniversaryText;
        if (this.props.settings.isBirthday) {
          const userDate = user.birthday ? user.birthday.toISOString().split('T')[0].split('-') : undefined;
          const date = new Date();
          const isBirthdayNextYear = new Date(`${date.getFullYear()}-${userDate[1]}-${userDate[2]}`).getTime() > Date.now();
          const birthDayDate = new ConditionalOutput(`${date.getFullYear()}-${userDate[1]}-${userDate[2]}`)
            .OnCondition(isBirthdayNextYear, `${date.getFullYear() + 1}-${userDate[1]}-${userDate[2]}`)
            .Last();
          const anniversaryYear = Number(birthDayDate.split('-')[0]) - user.birthday.getFullYear();
          birthdayString = new ConditionalOutput(new LocalizationService().strings.Birthday_Years)
            .OnCondition(this.props.settings.isBirthday && !this.props.showAnniversaryYear, user.birthdayText)
            .OnCondition(this.props.settings.isBirthday && this.props.showAnniversaryYear, `${anniversaryYear} ${new LocalizationService().strings.Birthday_Years} - ${user.birthdayText}`)
            .Last();
        }
        let properties: any;
        properties =
          [
            {
              iconColor: "#333333",
              property: "PreferredName",
              value: user.name,
            },
            {
              property: "Birthday",
              value: birthdayString,
              iconColor: "#333333",
              iconTitle: "Balloons",
              iconSize: 20
            }
          ];
        if (this.props.properties) {
          this.props.properties.forEach(property => {
            switch (property) {
              case 'email':
                if (user.email && user.isToday) {
                  properties.push({
                    property: 'WorkEmail',
                    value: user.email,
                    iconColor: "#333333",
                    iconTitle: "Email",
                    iconSize: 15
                  });
                }
                break;
              case 'chat':
                if (user.email && user.isToday) {
                  properties.push({
                    property: 'TeamsChat',
                    value: user.email,
                    iconColor: "#333333",
                    iconTitle: "Chat",
                    iconSize: 15
                  });
                }
                break;
              case 'jobTitle':
                if (user.jobTitle) {
                  properties.push({
                    property: 'JobTitle',
                    value: user.jobTitle,
                    iconColor: "#333333",
                    iconTitle: "Briefcase",
                    iconSize: 15
                  });
                }
                break;
              case 'location':
                if (user.officeLocation) {
                  properties.push({
                    property: 'Location',
                    value: user.officeLocation,
                    iconColor: "#333333",
                    iconTitle: "Location",
                    iconSize: 15
                  });
                }
                break;
              case 'department':
                if (user.department) {
                  properties.push({
                    property: 'Department',
                    value: user.department,
                    iconColor: "#333333",
                    iconTitle: "Organization",
                    iconSize: 17
                  });
                }
                break;
              case 'company':
                if (user.company) {
                  properties.push({
                    property: 'Company',
                    value: user.company,
                    iconColor: "#333333",
                    iconTitle: "Building",
                    iconSize: 17
                  });
                }
                break;
              case 'phone':
                if (user.phone) {
                  properties.push({
                    property: 'Phone',
                    value: user.phone,
                    iconColor: "#333333",
                    iconTitle: "Phone",
                    iconSize: 17
                  });
                }
                break;
            }
          });
        }

        // Resizing height on cards
        let cardHeight = 50;
        if (this.props.properties && this.props.properties.length > 0) {
          cardHeight = (25 * this.props.properties.length) + 50;
        }
        //PeopleCard maybe
        users.push(
          <IAPeopleCard
            image={Helper.getProfileImageUrlFromImageAPI(Environment.getEnvironmentForImageAPI(this.props.environment),
              this.props.tenant, this.props.token, user.email)}
            userId={user.guid}
            properties={properties}
            fontSlots={this.props.fontSlots}
            floatImage={true}
            styles={{
              marginRight: currentRowNumber == numberOfCardsPerRow ? 0 : 20,
              marginBottom: 20,
              width: window.innerWidth < 667 ? window.innerWidth - 56 : maxCardWidthAvailable,
              maxWidth: this.props.isMobile ? "100%" : (window.innerWidth < 667 ? window.innerWidth - 56 : 286),
              borderRadius: this.props.borderRadius
            }}
            highlightColor={this.props.highlightColor}
            todayIcon={this.props.todayIcon}
            isToday={user.isToday}
            cardHeight={cardHeight}
            backgroundColor={"#ffffff"}
            isEditMode={this.props.isEditMode}
            userLoginName={user.email}
          />
        );

        cardsOnPage++;
        if (currentRowNumber == numberOfCardsPerRow || cardsOnPage == this.props.users.length) {
          currentRowNumber = 1;
        } else {
          currentRowNumber++;
        }
        if (cardsOnPage == this.props.users.length) {
          cardsOnPage = 0;
        }
      });
    } else {
      if (this.props.users && this.props.users.length === 0) {
        users.push(
          <div>
            {this.props.settings.message}
          </div>);
      }
    }

    let table = (
      <div
        className={styles.IA_birthdayContainer}
        style={{
          fontFamily: this.props.fontSlots?.body?.fontFamily
        }}
      >
        {users}
      </div>
    );


    return table;
  }

}